export default __webpack_public_path__ + "static/media/brain.def4bb91.png";